import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white section-padding">
        <div className="container-custom">
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              {t('privacy.title')}
            </h1>
            <p className="text-xl text-gray-200">
              {t('privacy.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="bg-white rounded-lg shadow-lg p-8">
                <div className="mb-8">
                  <p className="text-gray-600 text-sm mb-4">
                    {t('privacy.lastUpdated')}: {new Date().toLocaleDateString()}
                  </p>
                </div>

                <div className="space-y-8">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.introduction.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('privacy.sections.introduction.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.dataCollection.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('privacy.sections.dataCollection.content')}
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                      <li>{t('privacy.sections.dataCollection.items.personal')}</li>
                      <li>{t('privacy.sections.dataCollection.items.contact')}</li>
                      <li>{t('privacy.sections.dataCollection.items.company')}</li>
                      <li>{t('privacy.sections.dataCollection.items.service')}</li>
                    </ul>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.dataUsage.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('privacy.sections.dataUsage.content')}
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                      <li>{t('privacy.sections.dataUsage.items.service')}</li>
                      <li>{t('privacy.sections.dataUsage.items.communication')}</li>
                      <li>{t('privacy.sections.dataUsage.items.improvement')}</li>
                      <li>{t('privacy.sections.dataUsage.items.legal')}</li>
                    </ul>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.cookies.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('privacy.sections.cookies.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.dataSharing.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('privacy.sections.dataSharing.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.rights.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('privacy.sections.rights.content')}
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                      <li>{t('privacy.sections.rights.items.access')}</li>
                      <li>{t('privacy.sections.rights.items.correction')}</li>
                      <li>{t('privacy.sections.rights.items.deletion')}</li>
                      <li>{t('privacy.sections.rights.items.portability')}</li>
                      <li>{t('privacy.sections.rights.items.objection')}</li>
                    </ul>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.security.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {t('privacy.sections.security.content')}
                    </p>
                  </div>

                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {t('privacy.sections.contact.title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {t('privacy.sections.contact.content')}
                    </p>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-gray-700">
                                    <strong>K&BTrans</strong><br />
            {t('contact.email')}: info@kbtrans.eu<br />
                        {t('contact.phone')}: +48 577 083 279<br />
                        NIP: PL7811993702
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy; 